import axiosInstance from "@/axios";

export const state = {
    dashboardData: null,
    dashboardLoading: false,
    dashboardError: null,
};

export const mutations = {
    SET_DASHBOARD_DATA(state, data) {
        state.dashboardData = data;
    },
    SET_LOADING(state, loading) {
        state.dashboardLoading = loading;
    },
    SET_ERROR(state, error) {
        state.dashboardError = error;
    },
};

export const getters = {
    dashboardData: (state) => state.dashboardData,
    dashboardLoading: (state) => state.dashboardLoading,
    dashboardError: (state) => state.dashboardError,
};

export const actions = {
    async getDashboardData({ commit }) {
        commit("SET_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const response = await axiosInstance({ requiresAuth: true }).get("/agent/dashboard");
            // Axios interceptor returns the response body; API wraps payload in .data
            const data = response.data ?? response;
            commit("SET_DASHBOARD_DATA", data);
        } catch (error) {
            commit("SET_ERROR", error.response?.data?.message || "Failed to load dashboard");
        } finally {
            commit("SET_LOADING", false);
        }
    },
};
